<template>
  <li v-if="message && message.content"
      :contenteditable="isCurrent? false : true"
      @blur="edited"
      @keydown.enter="editing"
      @click="toEdit">
    {{message.content}}<span v-if="isCurrent">{{dot}}</span>
  </li>
</template>

<script>
export default {
  name: 'messageItem',
  data () {
    return {
      dot: '',
      interval: null
    }
  },
  props: [
    'message',
    'i', // 当前段落的key
    'isCurrent', // 是否为正在语音内容
    'editTheMessage'
  ],
  watch: {
    isCurrent (newVal) { // 监听是否为正在语音的内容, 为false时关闭计时器
      if (newVal === false && this.interval) {
        clearTimeout(this.interval)
        this.interval = null
      }
    },
    message (newVal) {
      if (newVal.finished === true) {
        // console.log('newVal:', newVal)
        // clearTimeout(this.interval)
        // this.interval = null
      }
    }
  },
  methods: {
    edited (e) { // 当编辑的段落失去焦点后,保存段落内容
      if (this.editTheMessage) {
        this.editTheMessage(this.$el.innerText, this.i)
      }
      this.$emit('toEdit', false)
    },
    editing (e) {
      let ele
      if (e.target.tagName === 'LI') {
        e.preventDefault()
        ele = e.target
        ele.blur()
      } else {
        ele = e.target.parentNode
      }
      let messageListDOM = ele.parentNode
      let {clientHeight, scrollHeight} = messageListDOM
      messageListDOM.scrollTop = scrollHeight - clientHeight
    },
    toEdit (e) {
      if (e.target.tagName === 'LI') {
        this.$emit('toEdit', true)
      }
    },
    intervalFn () { // 正在语音内容提示,计时器
      let len = 1
      this.interval = setInterval(() => {
        let dot = ''
        for (let i = 0; i <= len; i++) {
          dot += ' .'
        }
        this.dot = dot
        len = ++len % 3
      }, 600)
    }
  },
  created () {
    if (this.isCurrent) {
      this.intervalFn() // 创建定时器,提示为当前语音内容
    }
  },
  destroyed () { // 销毁组件时取消定时器
    clearTimeout(this.interval)
    this.interval = null
  }
}

</script>

<style scoped="scoped">
li {
  border-bottom: 1px solid;
  padding: 15px 0px;
  cursor: text;
  font-weight:400;
  display: block;
  width: 100%;
  box-sizing: border-box;
  color: #5f5e5e;
}
li:focus{
  outline: none;
  font-weight:400;
}
li>span{
  font-weight: 600;
  display: inline-block;
  width:120px;
}
/* .toBottom {
  background: #ff8466;
  width: 100px;
  height: 30px;
  border-radius: 10px;
  padding-bottom: 10px;
  position: absolute;
  right: 15px;
  bottom: -40px;
  cursor: pointer;
  transition: all 0.2s linear 0s;
}
.toBottom>input {
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  position: absolute;
  left: 50%;
  top:50%;
  width: 60px;
  height: 30px;
  margin-left: -40px;
  margin-top: -15px;
}
.toBottom:before {
  display: block;
  content: '';
  position: absolute;
  z-index: 99;
  top:0;
  left:0;
  right:0;
  bottom:0;
}
.toBottom:after {
  content: '';
  display: inline-block;
  width:0;
  height:0;
  border:8px solid transparent;
  border-top-color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: 22px;
  margin-top: -3px;
} */
.default li:focus{
  color:#161616;
}
.default li {
  border-bottom-color: rgba(0, 0, 0, .05);
}
.dark li:focus{
  color: #ffffff  ;
}
.dark li {
  color: #d8d8d8;
  border-bottom-color: #474747;
}
</style>



// WEBPACK FOOTER //
// src/components/MessageItem.vue